export enum eTaxCertificationStatus {
  inProgress = 'IN_PROGRESS',
  sent = 'SENT',
  validated = 'VALIDATED',
  cancelled = 'CANCELLED',
}

export const prettyTaxCertStatus: Record<eTaxCertificationStatus, string> = {
  [eTaxCertificationStatus.inProgress]: 'In Progress',
  [eTaxCertificationStatus.sent]: 'Sent',
  [eTaxCertificationStatus.validated]: 'Validated',
  [eTaxCertificationStatus.cancelled]: 'Cancelled',
};
